/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/

import React, { Component } from "react";
import Loader from "../../../component/loader";
import classes from "./viewPackage.module.css";
import { connect } from "react-redux";
import actionTypes from "../../../store/actions";
import BusApiCall from "../../../helper/axios";
import constants from "../../../helper/constants";
import { withTranslation } from "react-i18next";
import Breadcrumb from "../../../component/breadcrumb";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import { DefaultImage } from "../../../helper/setFallbackImages";
// import TextEditor from "../../../component/richTextEditor";
import TiptapEditor from "../../../component/richTextEditor/TiptapEditor";
import {
  EditorState,
  ContentState,
  convertToRaw,
  convertFromRaw,
  Modifier,
} from "draft-js";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { withNavigation } from "../../../helper/withNavigation";
import Carousel from "../../sales/product/main/carousel";
import Detail from "../../sales/product/detail/detail";
import Button from "../../../component/button";
import { Select } from "@mui/material";
import currencyFormatter from "../../../helper/currencyFormatter";

// Manage order page class
class ViewPackage extends Component {
  // Declare property values that belongs to the component
  state = {
    bread: [],
    productData: {},
    productImages: [],
    firstLevelFeatures: [],
    variants: [],
    basicDetail: {},
    // productOverviewState: EditorState.createEmpty(),
    // productTechSpecsState: EditorState.createEmpty(),
    // productWhatsIncludedState: EditorState.createEmpty(),
    productOverview: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    productTechSpecs: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    productWhatsIncluded: '{"blocks":[{"key":"978p","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{}}',
    loading: true,

    showImage: false,
    noOverview: false,
    noTechspecs: false,
    noWhatsincluded: false,
    images: [],
    name: '',
    description: '',
  };

  // Intial HTTP calls or data manipulation on page load
  componentDidMount() {
    this.props.setCompDidMount();
    let id = this.props.router.params.id;
    let search = new URLSearchParams(this.props.router.location.search);
    let packageType = search.get("type");

    // Request to fetch selected packaged solution details
    let apiCall = "";
    if (packageType === "myOfferings") {
      apiCall = `${constants.busInternalUrl}/catalog/products/${id}/packagedSolutions`;
    } else if (packageType === "availableOfferings") {
      apiCall = `${constants.busInternalUrl}/solutionProviderPackages/products/${id}?packageMode=edit&promoId=null&isMaster=true`;
    } else {
      apiCall = `${constants.busInternalUrl}/catalog/products/${id}/solutionProviderProductDetails`;
    }
    BusApiCall("GET", apiCall)
      .then((response) => {
        // Parse response data
        let res = JSON.parse(response.data.jsonResponse);
        var images = [];
        if (res.basicDetail.productMainImage) {
          images.push(res.basicDetail.productMainImage);
        }
        if (res.basicDetail.productAdditionalImage1) {
          images.push(res.basicDetail.productAdditionalImage1);
        }
        if (res.basicDetail.productAdditionalImage2) {
          images.push(res.basicDetail.productAdditionalImage2);
        }
        if (res.basicDetail.productAdditionalImage3) {
          images.push(res.basicDetail.productAdditionalImage3);
        }
        if (res.basicDetail.productAdditionalImage4) {
          images.push(res.basicDetail.productAdditionalImage4);
        }
        this.setState({ images: images, showImage: images.length > 0 });
        let bread = [
          {
            title:
              packageType === "availableOfferings"
                ? this.props.t("AVAILABLE_SOLUTIONS")
                : this.props.t("MY_SOLUTIONS"),
            url:
              packageType === "availableOfferings"
                ? "/availableOfferings"
                : "/myOfferings",
          },
          {
            title: `${res.basicDetail.productName}`,
            url: `/viewProduct/${id}`,
          },
        ];
        let firstLevelFeatures = Array.isArray(res.firstLevelFeatures)
          ? res.firstLevelFeatures
          : [];
        let variants = res.variants;
        this.setState(
          {
            bread,
            productData: res,
            basicDetail: res.basicDetail,
            loading: false,
            firstLevelFeatures,
            variants,
            name: res.basicDetail.productName,
            description: res.basicDetail.productDescription,
          },
          () => {
            // var initialProductOverview = JSON.parse(
            //   this.state.basicDetail.productOverview,
            // );
            // var convertedProductOverview = convertFromRaw(
            //   initialProductOverview,
            // );

            // var initialTechSpecs = JSON.parse(
            //   this.state.basicDetail.productTechSpecs,
            // );
            // var convertedProductTechSpecs = convertFromRaw(initialTechSpecs);

            // var initialWhatsIncluded = JSON.parse(
            //   this.state.basicDetail.productWhatsIncluded,
            // );

            this.setState({
              productOverview: this.state.basicDetail.productOverview,
              productTechSpecs: this.state.basicDetail.productTechSpecs,
              productWhatsIncluded: this.state.basicDetail.productWhatsIncluded
            })
            // var convertedProductWhatsIncluded =
            //   convertFromRaw(initialWhatsIncluded);

            // this.setState({
            //   productOverviewState: EditorState.createWithContent(
            //     convertedProductOverview,
            //   ),
            //   productTechSpecsState: EditorState.createWithContent(
            //     convertedProductTechSpecs,
            //   ),
            //   productWhatsIncludedState: EditorState.createWithContent(
            //     convertedProductWhatsIncluded,
            //   ),
            // });
          },
        );
      })
      .catch((err) => {
        if (err.response && err.response.data && err.response.data.message) {
          this.props.setErrorMessage(err.response.data.message, false);
        } else {
          this.props.setErrorMessage("Something went wrong", false);
        }
        this.setState({ loading: false });
      });
  }

  checker = (arr, target) => target.every((v) => arr.includes(v));

  getVariantInfo = (a) => {
    let fe = [a.id];
    for (let i = 0; i < this.state.firstLevelFeatures.length; i++) {
      fe.push(this.state.firstLevelFeatures[i].selected);
    }
    for (let i = 0; i < this.state.variants.length; i++) {
      a.checkPrice = null;
      if (
        this.state.variants[i].features.length === fe.length &&
        this.checker(this.state.variants[i].features, fe)
      ) {
        a.checkPrice = this.state.variants[i].price;
        a.checkId = this.state.variants[i].id;
        break;
      }
    }
    return a.checkPrice;
  };

  setPrice = () => {
    // check if  variant is allowed
    let mPriceDisp = "";
    let mPrice = 10000000000;
    let productData = this.state.productData;
    let solutions = this.state.productData.solutions;
    if (solutions) {
      let newSols = solutions.options.filter((a) => this.getVariantInfo(a));
      let priceFunction = (price, id, promo) => {
        let pPrice = null;
        if (promo) {
          pPrice = promo.priceAdjustments
            ? promo.priceAdjustments[id]
              ? promo.priceAdjustments[id].price
              : null
            : null;
        }
        if (parseInt(price.purchasePrice) === -1 && pPrice === null) {
          return null;
        } else if (parseInt(pPrice) === -1) {
          return null;
        } else if (price.recurringPrice) {
          return Number(pPrice ? pPrice : price.recurringPrice.price);
        }
      };
      // find correct price with promo
      for (let i = 0; i < newSols.length; i++) {
        let price = priceFunction(newSols[i].checkPrice, newSols[i].checkId);
        if (price !== null && price < mPrice) {
          mPrice = price;
          mPriceDisp = price;
        }
      }
    }
    if (mPrice === 10000000000 || productData.overrideStartingPrice) {
      mPrice = productData.startingPrice;
      mPriceDisp = mPrice;
    }
    return mPriceDisp;
  };

  // Render order view
  render() {
    let data = this.state.basicDetail;
    const t = this.props.t;
    return (
      <>
        <div className={"newContentWrapper"}>
          <div className={"breadcrumbWrapper"}>
            <div className={"breadcrumbContent"}>
              <Grid container>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <Breadcrumb list={this.state.bread} />
                </Grid>
              </Grid>
            </div>
          </div>
          <main>
            {/* <Paper
              className={classes.card}
              style={{ padding: "16px", borderRadius: "8px", border: "1px solid lightgrey" }}
              elevation={0}
            >
              <Grid
                container
                spacing={2}
                className={classes.infoDiv}
                style={{ backgroundColor: "rgba(255,255,255,0.75)" }}
              >
                <Grid
                  item
                  size={{
                    xs: 10,
                  }}
                >
                  <div className={classes.detailDiv}>
                    <h2 className={classes.description}>{data.productName}</h2>
                    <p style={{ marginTop: 0 }}>{data.productDescription}</p>
                  </div>
                </Grid>
                <Grid
                  item
                  align={"right"}
                  style={{ backgroundColor: "rgba(255,255,255,0.75)" }}
                  size={{
                    xs: 2,
                  }}
                >
                  {this.props.providerType === "SALES_CHNL_PROVIDER" &&
                    this.props.menuPaths.includes("/newOrder/:id") &&
                    this.props.userPerms.includes("ORDERMGR_SALES_CREATE") && (
                      <Tooltip
                        title={
                          this.props.quoteEnabled
                            ? this.props.t("CREATE_QUOTE")
                            : this.props.t("PLACE_ORDER")
                        }
                      >
                        <svg
                          className={classes.addToCartIcon}
                          style={{
                            position: "initial",
                            width: "30px",
                            height: "30px",
                          }}
                          viewBox="0 0 29 36"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            this.props.router.navigate({
                              pathname: `/newOrder/${this.state.productData.productId}`,
                              statestate: {
                                availableCustomers:
                                  this.state.productData.customer &&
                                    this.state.productData.customer.length > 0
                                    ? this.state.productData.customer
                                    : [],
                              },
                            });
                          }}
                        >
                          <path
                            d="M14.1872 16.1379H17.0247V11.5543H21.2808V8.4986H17.0247V3.91504H14.1872V8.4986H9.93105V11.5543H14.1872V16.1379ZM8.51233 29.8885C6.95173 29.8885 5.68907 31.2636 5.68907 32.9443C5.68907 34.6249 6.95173 36 8.51233 36C10.0729 36 11.3498 34.6249 11.3498 32.9443C11.3498 31.2636 10.0729 29.8885 8.51233 29.8885ZM22.6995 29.8885C21.1389 29.8885 19.8763 31.2636 19.8763 32.9443C19.8763 34.6249 21.1389 36 22.6995 36C24.2601 36 25.537 34.6249 25.537 32.9443C25.537 31.2636 24.2601 29.8885 22.6995 29.8885ZM8.75351 24.923L8.79607 24.7397L10.0729 22.2493H20.6424C21.7064 22.2493 22.6428 21.6229 23.1252 20.6756L28.6014 9.96534L26.1328 8.4986H26.1187L24.5581 11.5543L20.6424 19.1936H10.683L10.4985 18.7811L7.3206 11.5543L5.97282 8.4986L4.63922 5.44289H0V8.4986H2.83744L7.94484 20.095L6.02956 23.8382C5.80257 24.266 5.67488 24.7702 5.67488 25.305C5.67488 26.9856 6.95173 28.3607 8.51233 28.3607H25.537V25.305H9.10819C8.92375 25.305 8.75351 25.1369 8.75351 24.923Z"
                            fill={this.props.tenantData.color}
                          />
                          <rect
                            x="9.93115"
                            y="3.91504"
                            width="11.3498"
                            height="12.2228"
                            fill="white"
                          />
                          <path
                            d="M24.2072 8.06904H20.4831V11.7932H19.2417V8.06904H15.5176V6.82766H19.2417V3.10352H20.4831V6.82766H24.2072V8.06904Z"
                            fill={this.props.tenantData.color}
                          />
                        </svg>
                      </Tooltip>
                    )}
                </Grid>
                <Grid
                  item
                  style={{ marginBottom: "15px" }}
                  className={classes.imageWrapper}
                  size={{
                    xs: 12,
                  }}
                >
                  {data.productMainImage && (
                    <img
                      onError={DefaultImage}
                      src={constants.imageUrl + data.productMainImage}
                      alt={data.productMainImage}
                    />
                  )}
                  {data.productAdditionalImage1 && (
                    <img
                      onError={DefaultImage}
                      src={constants.imageUrl + data.productAdditionalImage1}
                      alt={data.productAdditionalImage1}
                    />
                  )}
                  {data.productAdditionalImage2 && (
                    <img
                      onError={DefaultImage}
                      src={constants.imageUrl + data.productAdditionalImage2}
                      alt={data.productAdditionalImage2}
                    />
                  )}
                  {data.productAdditionalImage3 && (
                    <img
                      onError={DefaultImage}
                      src={constants.imageUrl + data.productAdditionalImage3}
                      alt={data.productAdditionalImage3}
                    />
                  )}
                  {data.productAdditionalImage4 && (
                    <img
                      onError={DefaultImage}
                      src={constants.imageUrl + data.productAdditionalImage4}
                      alt={data.productAdditionalImage4}
                    />
                  )}
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <TiptapEditor
                    value={this.state.productOverview}
                    readOnly={true}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <TiptapEditor
                    value={this.state.productTechSpecs}
                    readOnly={true}
                  />
                </Grid>
                <Grid
                  item
                  size={{
                    xs: 12,
                  }}
                >
                  <TiptapEditor
                    editorState={this.state.productWhatsIncluded}
                    readOnly={true}
                  />
                </Grid>
              </Grid>
            </Paper> */}
            <Grid container spacing={2} className={classes.infoDiv}>
              <>
                <Grid
                  item
                  size={{
                    xs: 12,
                    md: 12,
                  }}
                >
                  <Paper
                    className={classes.card}
                    style={{ padding: "16px", borderRadius: "8px" }}
                    elevation={0}
                  >
                    <Grid container spacing={3}>
                      {this.state.showImage ? (
                        <>
                          <Grid
                            item
                            alignItems="center"
                            size={{
                              xs: 12,
                              md: 4,
                            }}
                          >
                            <Carousel
                              images={this.state.images}
                              color={this.props.tenantData.color}
                            />
                          </Grid>
                        </>
                      ) : (
                        <>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 2,
                            }}
                          ></Grid>
                        </>
                      )}
                      <Grid
                        item
                        className={classes.productCardDetails}
                        size={{
                          xs: 12,
                          md: 8,
                        }}
                      >
                        <Grid container spacing={3}>
                          <Grid
                            item
                            align="left"
                            size={{
                              xs: 12,
                            }}
                          >
                            <h2
                              className={classes.itemName}
                              style={{
                                marginTop: "0",
                                marginBottom: "12px",
                              }}
                            >
                              {this.state.name}
                            </h2>
                            <p
                              className={classes.itemDescription}
                              style={{ marginTop: "0" }}
                            >
                              {this.state.description}
                            </p>
                          </Grid>
                        </Grid>

                        {/* <Grid
                          container
                          spacing={2}
                          style={{ marginBottom: "4rem" }}
                        >
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            <div className={classes.itemPriceWrapper}>
                              {(this.props.providerType ===
                                "SALES_CHNL_PROVIDER" ||
                                this.props.publicBrowsing) && (
                                  <>
                                    {this.state.isBundle && (
                                      <span
                                        className={classes.itemPriceLabel}
                                      >
                                        {t("STARTING_FROM_TEXT")}
                                      </span>
                                    )}
                                    <span
                                      className={classes.itemPrice}
                                      style={{
                                        color: this.props.tenantData.color,
                                      }}
                                    >
                                      {currencyFormatter(
                                        this.state.startingPrice
                                          ? this.state.startingPrice
                                          : 0,
                                      )}
                                      {t("PER_MONTH")}
                                    </span>
                                  </>
                                )}
                              {this.state.promos &&
                                this.state.promos.length > 0 ? (
                                <div style={{ marginTop: "10px" }}>
                                  <Select
                                    default={t("STANDARD_PRICING_OPTIONS")}
                                    options={this.state.promos}
                                    optionLabel={(item) => item.text}
                                    selected={
                                      this.state.selectedPromo
                                        ? this.state.selectedPromo.id
                                        : ""
                                    }
                                    name="selectedPromo"
                                    value={(item) => item.id}
                                    onChange={(e) => {
                                      this.onChangePromo(e);
                                    }}
                                    disabled={this.state.disableCreateQuote}
                                  />
                                </div>
                              ) : null}
                            </div>
                          </Grid>
                          <Grid
                            item
                            size={{
                              xs: 12,
                              md: 9,
                            }}
                          >
                            <div
                              className={classes.itemMainButtonWrapper}
                              align="left"
                            >
                              {this.state.showCheckAvailability && (
                                <Button
                                  className={classes.itemMainButton}
                                  style={{ marginRight: 15 }}
                                  onClick={this.checkAvailability}
                                  disabled={this.state.disableCreateQuote}
                                >
                                  {t("CHECK_AVAILABILITY")}
                                </Button>
                              )}
                              {this.state.placeOrder && (
                                <Button
                                  className={classes.itemMainButton}
                                  onClick={() => {
                                    this.verifyPromoBan();
                                  }}
                                  disabled={this.state.disableCreateQuote}
                                >
                                  {this.props.providerType ===
                                    "SALES_CHNL_PROVIDER" ||
                                    this.props.publicBrowsing
                                    ? "Customize and Buy"
                                    : "Customize"}
                                </Button>
                              )}
                            </div>
                          </Grid>
                        </Grid> */}
                      </Grid>
                    </Grid>
                  </Paper>
                </Grid>
                {(JSON.parse(this.state.productOverview).blocks[0].text.length >
                  0 ||
                  JSON.parse(this.state.productTechSpecs).blocks[0].text.length >
                  0 ||
                  JSON.parse(this.state.productWhatsIncluded).blocks[0].text
                    .length > 0) && (
                    <Grid
                      item
                      size={{
                        xs: 12,
                        md: 12,
                      }}
                    >
                      <Paper
                        className={classes.card}
                        style={{ padding: "16px", borderRadius: "8px" }}
                        elevation={0}
                      >
                        <Detail
                          id={this.state.id}
                          overView={this.state.productOverview}
                          noOverview={this.state.noOverview}
                          techSpecs={this.state.productTechSpecs}
                          noTechspecs={this.state.noTechspecs}
                          whatsIncluded={this.state.productWhatsIncluded}
                          noWhatsincluded={this.state.noWhatsincluded}
                        />
                      </Paper>
                    </Grid>
                  )}
              </>
            </Grid>
            <Loader loading={this.state.loading} />
          </main>
        </div>
      </>
    );
  }
}

// Fetch data from redux store
const mapStateToProps = (state) => {
  return {
    category: state.cart.category,
    providerId: state.auth.tenantId,
    providerType: state.auth.providerType,
    tenantData: state.auth.tenantData,
    menuPaths: state.auth.menuPaths,
    userPerms: state.auth.userPerms,
    quoteEnabled: state.auth.quoteEnabled,
  };
};

// Set data to redux store
const mapDispatchToProps = (dispatch) => {
  return {
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setErrorMessage: (errMsg, msgType) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation("translations")(withNavigation(ViewPackage)));
